import React from 'react';

import Layout from '../layout/Layout';
import SignInForm from './SignInForm';
import AlertProvider from '../components/contexts/AlertProvider';

import './SignInPage.css';

/**
 * 
 * @returns 
 */
const SignInPage = () => {
    /**
     * 
     */
    return (
        <AlertProvider>
            <Layout title='Se connecter'>
                <SignInForm />
            </Layout>
        </AlertProvider>
    );
};

export default SignInPage;
